import Vue from 'vue';
import BelegtypService from './belegtyp.service';

const getDefaultItem = () => ({
    id: null,
});

const getDefaultState = () => ({
    item: getDefaultItem(),
    list: [],
});

const belegtyp = {
    namespaced: true,

    state: Object.assign({}, getDefaultState()),

    mutations: {
        update(state, data) {
            Vue.set(state, 'item', data);
        },
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        clear(state) {
            Vue.set(state, 'item', getDefaultState().item);
            Vue.set(state, 'list', getDefaultState().list);
        },
    },

    actions: {
        clear({ commit }) {
            commit('clear');
        },
        setBelegTypen(context, belegtypen) {
            context.commit('updateList', belegtypen);
        },
        async create(context, client_data) {
            const { data } = await BelegtypService.create(client_data);
            context.commit('update', data);
            return data;
        },
        async update(context, client_data) {
            const { data } = await BelegtypService.update(client_data.id, client_data);
            context.commit('update', data);
            return data;
        },
        async get(context, id) {
            const { data } = await BelegtypService.get(id);
            context.commit('update', data);
            return data;
        },
        async query(context, params) {
            const { data } = await BelegtypService.query(params);
            const belegtypen = data;
            belegtypen.sort((a, b) => {
                let compare = 0;
                if (a > b) {
                    compare = 1;
                } else if (b > a) {
                    compare = -1;
                }
                return compare;
            });
            context.commit('updateList', belegtypen);
            return belegtypen;
        },
        async delete(context, slug) {
            await BelegtypService.delete(slug);
        },
    },

    getters: {
        data(state) {
            return state.item;
        },
        list(state) {
            return state.list;
        },
    },
};

export default belegtyp;
